import {Medications} from './Medications';
export default Medications;
